import { Navigate, useLocation } from 'react-router-dom';

import useMaintenanceStore from '@/store/useMaintenanceStore';
import useUser from '@/store/useUser';

const MaintenanceGuard = ({ children }: { children: React.ReactNode }) => {
  const { isMaintenanceMode } = useMaintenanceStore();
  const token = useUser((state) => state.user.token);
  const location = useLocation();

  const isOnMaintenancePage = location.pathname === '/maintenance';

  // Not logged in → skip maintenance guard, let auth routes handle it
  if (!token) {
    return <>{children}</>;
  }

  // Maintenance ON → force redirect to /maintenance
  if (isMaintenanceMode && !isOnMaintenancePage) {
    return <Navigate to="/maintenance" replace />;
  }

  // Maintenance OFF → redirect away from /maintenance
  if (!isMaintenanceMode && isOnMaintenancePage) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default MaintenanceGuard;
